import * as Yup from 'yup';

export const equipmentValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Nome do equipamento é obrigatório')
    .min(3, 'Nome deve ter no mínimo 3 caracteres'),
  
  serialWiegan: Yup.string()
    .required('Serial Wiegan é obrigatório')
    .matches(/^W\d{9}$/, 'Serial Wiegan deve começar com W seguido de 9 dígitos'),
  
  mac: Yup.string()
    .required('Endereço MAC é obrigatório'),
  
  direction: Yup.string()
    .required('Direção é obrigatória'),
  
  counter: Yup.number()
    .min(0, 'Contador não pode ser negativo')
    .required('Contador é obrigatório'),
  
  receptors: Yup.number()
    .min(1, 'Deve ter pelo menos 1 receptor')
    .required('Número de receptores é obrigatório'),
  
  hosts: Yup.number()
    .min(1, 'Deve ter pelo menos 1 host')
    .required('Número de hosts é obrigatório'),
  
  portQuantity: Yup.number()
    .min(1, 'Deve ter pelo menos 1 porta')
    .required('Número de portas é obrigatório'),
  
  finalPortQuantity: Yup.number()
    .min(1, 'Deve ter pelo menos 1 porta final')
    .required('Número de portas finais é obrigatório'),
  
  roomId: Yup.string()
    .required('Área é obrigatória'),
}); 